import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { GUIDES } from "../seoGuides";
import { Seo, SITE } from "../components/Seo";

export default function GuidesIndex() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "Privacy Guides",
      description: "Free step-by-step privacy guides from Ghost The Grid.",
      url: `${SITE}/guides`,
      hasPart: GUIDES.map((g) => ({ "@type": "Article", name: g.h1, url: `${SITE}/guides/${g.slug}` })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${SITE}/` },
        { "@type": "ListItem", position: 2, name: "Privacy Guides", item: `${SITE}/guides` },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-[#050505] text-white noise-overlay">
      <Seo
        title="Privacy Guides — Remove Yourself From Data Brokers & Stop Tracking"
        description="Free step-by-step privacy guides: remove yourself from data brokers, stop location tracking, delete search history, and lock down your accounts."
        path="/guides"
        jsonLd={jsonLd}
      />
      <header className="border-b border-white/10">
        <div className="max-w-[1000px] mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" data-testid="guides-logo-link" className="font-display font-black uppercase tracking-tighter text-lg">Ghost The Grid</Link>
          <Link to="/" className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/60 hover:text-accent transition-colors">Get The Pack →</Link>
        </div>
      </header>
      <div className="max-w-[1000px] mx-auto px-6 py-16 lg:py-24">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-accent">// Free Privacy Guides</span>
        <h1 className="mt-5 font-display font-black uppercase tracking-tighter text-4xl sm:text-6xl leading-[0.9]">Take back your privacy,<br />one step at a time</h1>
        <p className="mt-6 font-body text-white/50 leading-relaxed max-w-xl">Real, no-jargon answers to the questions people actually search. Each guide is genuinely useful on its own, and part of the complete Ghost The Grid system.</p>
        <div className="mt-12 grid sm:grid-cols-2 gap-4">
          {GUIDES.map((g) => (
            <Link key={g.slug} to={`/guides/${g.slug}`} data-testid={`guide-card-${g.slug}`}
              className="group border border-white/10 p-6 hover:border-accent transition-colors flex items-start justify-between gap-4">
              <div>
                <span className="font-mono text-accent text-xs">NODE {g.node}</span>
                <h2 className="mt-2 font-body text-base text-white/85 group-hover:text-white leading-snug">{g.h1}</h2>
              </div>
              <ArrowRight size={18} className="text-accent flex-shrink-0 mt-1" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
